/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TokenLoginImport } from './routes/token-login'
import { Route as LoginImport } from './routes/login'
import { Route as AboutImport } from './routes/about'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as AuthHomeImport } from './routes/_auth/home'
import { Route as AuthTeacherIndexImport } from './routes/_auth/teacher/index'
import { Route as AuthStudentIndexImport } from './routes/_auth/student/index'
import { Route as AuthOperationsIndexImport } from './routes/_auth/operations/index'
import { Route as AuthOperationsWorksheetSetsIndexImport } from './routes/_auth/operations/worksheet-sets/index'
import { Route as AuthOperationsSchedulesIndexImport } from './routes/_auth/operations/schedules/index'
import { Route as AuthOperationsAssignmentsIndexImport } from './routes/_auth/operations/assignments/index'
import { Route as AuthTeacherSessionSessionIdIndexImport } from './routes/_auth/teacher/session/$sessionId/index'
import { Route as AuthOperationsWorksheetSetsWorksheetWorksheetIdImport } from './routes/_auth/operations/worksheet-sets/worksheet/$worksheetId'
import { Route as AuthTeacherSessionSessionIdStudentUserIdIndexImport } from './routes/_auth/teacher/session/$sessionId/student/$userId/index'
import { Route as AuthStudentSessionSessionIdSetSetVersionIdWorksheetWorksheetVersionIdImport } from './routes/_auth/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId'
import { Route as AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdScoresIndexImport } from './routes/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/index'
import { Route as AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdWorksheetWorksheetVersionIdImport } from './routes/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId'

// Create/Update Routes

const TokenLoginRoute = TokenLoginImport.update({
  path: '/token-login',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthHomeRoute = AuthHomeImport.update({
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTeacherIndexRoute = AuthTeacherIndexImport.update({
  path: '/teacher/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthStudentIndexRoute = AuthStudentIndexImport.update({
  path: '/student/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOperationsIndexRoute = AuthOperationsIndexImport.update({
  path: '/operations/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOperationsWorksheetSetsIndexRoute =
  AuthOperationsWorksheetSetsIndexImport.update({
    path: '/operations/worksheet-sets/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthOperationsSchedulesIndexRoute =
  AuthOperationsSchedulesIndexImport.update({
    path: '/operations/schedules/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthOperationsAssignmentsIndexRoute =
  AuthOperationsAssignmentsIndexImport.update({
    path: '/operations/assignments/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthTeacherSessionSessionIdIndexRoute =
  AuthTeacherSessionSessionIdIndexImport.update({
    path: '/teacher/session/$sessionId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthOperationsWorksheetSetsWorksheetWorksheetIdRoute =
  AuthOperationsWorksheetSetsWorksheetWorksheetIdImport.update({
    path: '/operations/worksheet-sets/worksheet/$worksheetId',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthTeacherSessionSessionIdStudentUserIdIndexRoute =
  AuthTeacherSessionSessionIdStudentUserIdIndexImport.update({
    path: '/teacher/session/$sessionId/student/$userId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthStudentSessionSessionIdSetSetVersionIdWorksheetWorksheetVersionIdRoute =
  AuthStudentSessionSessionIdSetSetVersionIdWorksheetWorksheetVersionIdImport.update(
    {
      path: '/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdScoresIndexRoute =
  AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdScoresIndexImport.update(
    {
      path: '/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdWorksheetWorksheetVersionIdRoute =
  AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdWorksheetWorksheetVersionIdImport.update(
    {
      path: '/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId',
      getParentRoute: () => AuthRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/token-login': {
      id: '/token-login'
      path: '/token-login'
      fullPath: '/token-login'
      preLoaderRoute: typeof TokenLoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeImport
      parentRoute: typeof AuthImport
    }
    '/_auth/operations/': {
      id: '/_auth/operations/'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthOperationsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/student/': {
      id: '/_auth/student/'
      path: '/student'
      fullPath: '/student'
      preLoaderRoute: typeof AuthStudentIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/teacher/': {
      id: '/_auth/teacher/'
      path: '/teacher'
      fullPath: '/teacher'
      preLoaderRoute: typeof AuthTeacherIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/operations/assignments/': {
      id: '/_auth/operations/assignments/'
      path: '/operations/assignments'
      fullPath: '/operations/assignments'
      preLoaderRoute: typeof AuthOperationsAssignmentsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/operations/schedules/': {
      id: '/_auth/operations/schedules/'
      path: '/operations/schedules'
      fullPath: '/operations/schedules'
      preLoaderRoute: typeof AuthOperationsSchedulesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/operations/worksheet-sets/': {
      id: '/_auth/operations/worksheet-sets/'
      path: '/operations/worksheet-sets'
      fullPath: '/operations/worksheet-sets'
      preLoaderRoute: typeof AuthOperationsWorksheetSetsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/operations/worksheet-sets/worksheet/$worksheetId': {
      id: '/_auth/operations/worksheet-sets/worksheet/$worksheetId'
      path: '/operations/worksheet-sets/worksheet/$worksheetId'
      fullPath: '/operations/worksheet-sets/worksheet/$worksheetId'
      preLoaderRoute: typeof AuthOperationsWorksheetSetsWorksheetWorksheetIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/teacher/session/$sessionId/': {
      id: '/_auth/teacher/session/$sessionId/'
      path: '/teacher/session/$sessionId'
      fullPath: '/teacher/session/$sessionId'
      preLoaderRoute: typeof AuthTeacherSessionSessionIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/teacher/session/$sessionId/student/$userId/': {
      id: '/_auth/teacher/session/$sessionId/student/$userId/'
      path: '/teacher/session/$sessionId/student/$userId'
      fullPath: '/teacher/session/$sessionId/student/$userId'
      preLoaderRoute: typeof AuthTeacherSessionSessionIdStudentUserIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId': {
      id: '/_auth/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId'
      path: '/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId'
      fullPath: '/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId'
      preLoaderRoute: typeof AuthStudentSessionSessionIdSetSetVersionIdWorksheetWorksheetVersionIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId': {
      id: '/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId'
      path: '/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId'
      fullPath: '/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId'
      preLoaderRoute: typeof AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdWorksheetWorksheetVersionIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/': {
      id: '/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/'
      path: '/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores'
      fullPath: '/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores'
      preLoaderRoute: typeof AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdScoresIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AuthRoute: AuthRoute.addChildren({
    AuthHomeRoute,
    AuthOperationsIndexRoute,
    AuthStudentIndexRoute,
    AuthTeacherIndexRoute,
    AuthOperationsAssignmentsIndexRoute,
    AuthOperationsSchedulesIndexRoute,
    AuthOperationsWorksheetSetsIndexRoute,
    AuthOperationsWorksheetSetsWorksheetWorksheetIdRoute,
    AuthTeacherSessionSessionIdIndexRoute,
    AuthTeacherSessionSessionIdStudentUserIdIndexRoute,
    AuthStudentSessionSessionIdSetSetVersionIdWorksheetWorksheetVersionIdRoute,
    AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdWorksheetWorksheetVersionIdRoute,
    AuthTeacherSessionSessionIdStudentUserIdSetSetVersionIdScoresIndexRoute,
  }),
  AboutRoute,
  LoginRoute,
  TokenLoginRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/about",
        "/login",
        "/token-login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/home",
        "/_auth/operations/",
        "/_auth/student/",
        "/_auth/teacher/",
        "/_auth/operations/assignments/",
        "/_auth/operations/schedules/",
        "/_auth/operations/worksheet-sets/",
        "/_auth/operations/worksheet-sets/worksheet/$worksheetId",
        "/_auth/teacher/session/$sessionId/",
        "/_auth/teacher/session/$sessionId/student/$userId/",
        "/_auth/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId",
        "/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId",
        "/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/"
      ]
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/token-login": {
      "filePath": "token-login.tsx"
    },
    "/_auth/home": {
      "filePath": "_auth/home.tsx",
      "parent": "/_auth"
    },
    "/_auth/operations/": {
      "filePath": "_auth/operations/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/student/": {
      "filePath": "_auth/student/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/teacher/": {
      "filePath": "_auth/teacher/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/operations/assignments/": {
      "filePath": "_auth/operations/assignments/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/operations/schedules/": {
      "filePath": "_auth/operations/schedules/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/operations/worksheet-sets/": {
      "filePath": "_auth/operations/worksheet-sets/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/operations/worksheet-sets/worksheet/$worksheetId": {
      "filePath": "_auth/operations/worksheet-sets/worksheet/$worksheetId.tsx",
      "parent": "/_auth"
    },
    "/_auth/teacher/session/$sessionId/": {
      "filePath": "_auth/teacher/session/$sessionId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/teacher/session/$sessionId/student/$userId/": {
      "filePath": "_auth/teacher/session/$sessionId/student/$userId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId": {
      "filePath": "_auth/student/session/$sessionId/set/$setVersionId/worksheet/$worksheetVersionId.tsx",
      "parent": "/_auth"
    },
    "/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId": {
      "filePath": "_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/worksheet/$worksheetVersionId.tsx",
      "parent": "/_auth"
    },
    "/_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/": {
      "filePath": "_auth/teacher/session/$sessionId/student/$userId/set/$setVersionId/scores/index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
